import React from "react";
import PropTypes from "prop-types";
import SimpleLabelContainer from "../labels/container.simple_label.jsx";

export const TaskLabelsList = ({ labels }) => {
  return labels.length > 0
    ? labels.map((labelId) => (
        <SimpleLabelContainer
          id={labelId}
          key={labelId}
          as="dot"
        />
      ))
    : null;
};

TaskLabelsList.propTypes = {
  labels: PropTypes.array,
};

TaskLabelsList.defaultProps = {
  labels: [],
};
